import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=c1e80a24&scoped=true"
import script from "./noticePage.vue?vue&type=script&lang=js"
export * from "./noticePage.vue?vue&type=script&lang=js"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=c1e80a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e80a24",
  null
  
)

export default component.exports